<template>
  <div class="daily-by-code-export-page-container">
    <!-- <v-row>
      <v-col cols="12">
        <v-card height="97vh" style="overflow-y: auto"> -->
    <div id="viewer2" dir="ltr"></div>
    <!-- </v-card>
      </v-col>
    </v-row> -->
  </div>
</template>
<script>
//import Vue from "vue";
import ShearedMixin from '@/Mixins/Shared.js';
import ReportMixin from '@/Mixins/Report/ReportMixin.js';
export default {
  name: 'app',
  inject: ['load'],
  mixins: [ShearedMixin, ReportMixin],
  data() {
    return {
      reportType: '',
    };
  },
  created() { },
  mounted: function () {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      let routeInfo = this.$route.params.id;
      let data = routeInfo.split('_');
      if (!isNaN(data[2])) {
        data[2] = Number(data[2]);
      } else {
        data[2] = null;
      }
      this.getDailyByGeographicalTypeWithCodeReportAmarFunction(data[0], data[1], data[2]);
    },
    makeDataReady: function (info) {
      window.Stimulsoft.Base.StiLicense.Key =
        '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkcgIvwL0jnpsDqRpWg5FI5kt2G7A0tYIcUygBh1sPs7plofUOqPB1a4HBIXJB621mau2oiAIj+ysU7gKUXfjn/D5BocmduNB+ZMiDGPxFrAp3PoD0nYNkkWh8r7gBZ1v/JZSXGE3bQDrCQCNSy6mgby+iFAMV8/PuZ1z77U+Xz3fkpbm6MYQXYp3cQooLGLUti7k1TFWrnawT0iEEDJ2iRcU9wLqn2g9UiWesEZtKwI/UmEI2T7nv5NbgV+CHguu6QU4WWzFpIgW+3LUnKCT/vCDY+ymzgycw9A9+HFSzARiPzgOaAuQYrFDpzhXV+ZeX31AxWlnzjDWqpfluygSNPtGul5gyNt2CEoJD1Yom0VN9fvRonYsMsimkFFx2AwyVpPcs+JfVBtpPbTcZscnzUdmiIvxv8Gcin6sNSibM6in/uUKFt3bVgW/XeMYa7MLGF53kvBSwi78poUDigA2n12SmghLR0AHxyEDIgZGOTbNI33GWu7ZsPBeUdGu55R8w=';
      let options = new window.Stimulsoft.Viewer.StiViewerOptions();
      let viewer2 = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
      let report = new window.Stimulsoft.Report.StiReport();
      let dataSet1 = new window.Stimulsoft.System.Data.DataSet('Data');
      // var myJsonString = JSON.stringify(info.withinCityItems);
      var myJsonString = JSON.stringify(info.detailsItems);
      dataSet1.readJson(myJsonString);
      // let dataSet2 = new window.Stimulsoft.System.Data.DataSet('DataOutOfCityCopy');
      // var myJsonString2 = JSON.stringify(info.outOfCityItems);
      // dataSet2.readJson(myJsonString2);
      report.regData(dataSet1.dataSetName, '', dataSet1.tables.list[0]);
      // report.regData(dataSet2.dataSetName, '', dataSet2.tables.list[0]);
      report.dictionary.synchronize();

      report.loadFile('/Files/DailyReportMainWithGeographicalTypeByCode.mrt');
      report.dictionary.variables.getByName('fromDate').valueObject = info.fromDate;
      report.dictionary.variables.getByName('toDate').valueObject = info.toDate;
      report.dictionary.variables.getByName('user').valueObject = info?.user;
      report.dictionary.variables.getByName('city').valueObject = info?.title;
      report.dictionary.variables.getByName('createDate').valueObject = info.reportDate;
      // report.dictionary.variables.getByName('Consultant').valueObject =
      //   info?.callReport?.consultant;
      // report.dictionary.variables.getByName('Other').valueObject = info?.callReport?.other;
      // report.dictionary.variables.getByName('Prank').valueObject = info?.callReport?.prank;
      // report.dictionary.variables.getByName('SendToDispatch').valueObject =
      //   info?.callReport?.sendToDispatch;
      report.dictionary.synchronize();
      viewer2.report = report;
      viewer2.options.toolbar.viewMode = window.Stimulsoft.Viewer.StiWebViewMode.Continuous;
      viewer2.renderHtml('viewer2');
      if (this.load.val) {
        this.load.val = false;
      }
    },
  },
};
</script>

<style lang="scss">
.daily-by-code-export-page-container {
  #StiViewer_JsViewerMainPanel {
    height: 100dvh !important;
    overflow: auto !important;
  }

  #StiViewerReportPanel {
    overflow: auto !important;
  }
}
</style>
<style scoped>
>>>text {
  transform: translateX(-50px) !important;
}
</style>

<!-- <style scoped>
>>>.stiJsViewerPage>>>div {
  color: white !important;
}

>>>#StiViewerReportPanel {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
}

>>>#stiJsViewerReportPanel {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
}

.m-card {
  overflow-y: auto;
}

>>>.stiJsViewerReportPanel {
  margin-top: 75px !important;
}
</style> -->
